<template>
  <!-- 新增电源控制器 -->
  <div class="addModel myinput">
    <div class="addemBtns">
      新增电源控制器
    </div>
    <div>
      <div class="emid">
        <div>
          <span>名称</span>
          <el-input v-model="switchName" maxlength="100" ></el-input>
        </div>
        <div>
          <span>编号</span>
          <el-input v-model="powerId" maxlength="100" ></el-input>
        </div>
        <div>
          <span>MQTT主题</span>
          <el-input v-model="mqttApi" maxlength="100" ></el-input>
        </div>
        <div>
          <span>EUI</span>
          <el-input v-model="eui" maxlength="100" ></el-input>
        </div>
        <div>
          <span>额定功率</span>
          <el-input v-model.number="power" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </div>
        <div>
          <span>额定电压</span>
          <el-input v-model.number="electric" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </div>
      </div>
    </div>
    <div class="detailed">
      <div class="element-list jb-bg btn" @click="submit">确认</div>
      <div class="element-list jb-bg btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    myShow: Boolean,
  },
  data() {
    return {
      depotId: "", //仓库id
      switchName: "", // 名称
      powerId: "", //编号
      mqttApi: "", //mqtt主题
      eui: "", //电源控制器eui
      electric: "", //额定电压
      power: "", //额定功率
    };
  },
  created() {
    this.depotId = sessionStorage.getItem("depotId");
  },
  methods: {
    submit() {
      if (
        this.switchName.trim() == "" ||
        this.powerId.trim() == "" ||
        !this.electric ||
        !this.power
      ) {
        return this.$message.error("内容填写不完整，请填写完整后提交");
      }
      let data2 = {
        switchName: this.switchName,
        serialNumber: this.powerId,
        depotId: Number(this.depotId),
        mqttApi: this.mqttApi,
        eui: this.eui,
        electric: parseFloat(this.electric),
        power: parseFloat(this.power),
      };
      let params = JSON.parse(JSON.stringify(data2));
      this.$emit("submit", params, 2);
      this.switchName;
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  watch: {
    myShow(newVal, oldVal) {
      if (newVal) {
        this.depotId = sessionStorage.getItem("depotId");
        this.switchName = "";
        this.powerId = "";
        this.mqttApi = "";
        this.eui = "";
        this.electric = "";
        this.power = "";
      }
    },
  },
};
</script>

<style lang='less' scoped>
.select_option {
  background: #092e5f !important;
  color: #ffffff !important;
}
.addModel {
  height: 450px;
  color: #74c8fe;
  margin: 0 30px;
  .addemBtns {
    margin: 30px 10px;
    font-size: 20px;
  }
  .emid {
    height: 50px;
    line-height: 50px;
    .el-input {
      width: 260px;
      margin: 0px 15px;
    }
    span {
      display: -moz-inline-box;
      display: inline-block;
      width: 85px;
      text-align: center;
      text-align-last: justify;
    }
  }

  .detailed {
    margin: 0 30px 20px;
    clear: both;
    display: flex;
    position: absolute;
    bottom: 0px;
    .btn {
      width: 150px;
      margin-right: 10px;
      cursor: pointer;
    }

    .element-list {
      border: 2px solid#0090F0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 10px 5px;
      text-align: center;
    }
    .jb-bg {
      background-image: linear-gradient(#0479b4, #02407e);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/addPower.vue